import { type FC, useState } from 'react';
import { Link, type TestProps, Text, TextCell } from '@direct-frontend/components';
import { type OpenApiSchemaAddonIdTitlePair } from '#shared/api/schema';
import { pluralize } from '#shared/lib/string';

const COUNT_SHOWED_ADDONS = 1;

type ProductAddonsCellProps = {
    addons: OpenApiSchemaAddonIdTitlePair[];
    onClick?: VoidFunction;
    className?: string;
} & TestProps;

export const ProductAddonsCell: FC<ProductAddonsCellProps> = ({
    addons,
    onClick,
    className,
    'data-testid': dataTestId,
}) => {
    const [isVisibleButtonShowAll, setIsVisibleButtonShowAll] = useState(addons.length > COUNT_SHOWED_ADDONS);

    return (
        <TextCell
            onClick={onClick}
            className={className}
            data-testid={dataTestId}
            title={(textProps) => (
                <>
                    {addons.slice(0, isVisibleButtonShowAll ? COUNT_SHOWED_ADDONS : addons.length).map((addon) => (
                        <Text
                            key={addon.id}
                            {...textProps}
                            size="s"
                            maxLines={2}
                            data-testid={`${dataTestId}.Addon.${addon.id}`}
                        >
                            {addon.title}
                        </Text>
                    ))}
                    {isVisibleButtonShowAll && addons.length > COUNT_SHOWED_ADDONS ? (
                        <Text role="supplementary" size="xs">
                            <Link
                                data-testid={`${dataTestId}.ShowAllButton`}
                                onClick={() => setIsVisibleButtonShowAll(false)}
                                color="supplementary"
                            >
                                {pluralize(
                                    addons.length,
                                    `Показать все %d услугу`,
                                    `Показать все %d услуги`,
                                    `Показать все %d услуг`
                                )}
                            </Link>
                        </Text>
                    ) : null}
                </>
            )}
        />
    );
};
